import BaseComponent from './BaseComponent';
import Swal from "sweetalert2";

export default class AjaxDelete extends BaseComponent {

    protected deleteUrl: string | undefined;
    protected confirmTitle: string | undefined;
    protected confirmSuccess: string | undefined;
    protected confirmError: string | undefined;
    protected confirmButtonText: string | undefined;
    protected cancelButtonText: string | undefined;
    protected userId: string | undefined;

    protected initAdditionalVar() {
        this.deleteUrl = this.view.dataset.deleteUrl;
        this.confirmTitle = this.view.dataset.confirmTitle;
        this.confirmSuccess = this.view.dataset.confirmSuccess;
        this.confirmError = this.view.dataset.confirmError;
        this.confirmButtonText = this.view.dataset.confirmButtonText;
        this.cancelButtonText = this.view.dataset.cancelButtonText;
        this.userId = this.view.dataset.userId;
    }

    protected init(): void {
        // Le JS à initialiser
        this.view.addEventListener('click', (event) => {
            event.preventDefault();
            this.executeDeleteRow();
        });
    }

    private executeDeleteRow () {
        const self = this;

        //@ts-ignore
        Swal.fire({
            title: this.confirmTitle,
            text: '',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: this.cancelButtonText,
            confirmButtonText: this.confirmButtonText
        }).then(async (result) => {

            if (result.isConfirmed) {
                // For reminder : hegyd sendRequest args : url, method, data, callbackSuccess, callbackError
                (window as any).HegydCore.sendRequest(
                    self.deleteUrl,
                    'DELETE',
                    {},
                    function (data: object) { //Success
                        (window as any).toastr.success(self.confirmSuccess);
                        $('.user-container-'+self.userId).remove();
                    },
                    function (data: object) { //error
                        (window as any).toastr.error(self.confirmError);
                    }
                );
            }
        });
    }
}
